import {Plugin} from 'vuex'
import {Subject} from '@microsoft/signalr';
import RealtimeClient from '@/libs/core/realtime/realtime-client';
import {ObjectChangeEvent} from '@/libs/core/realtime/object-change-event';
import {createStoreDispatcher, createStoreGetter} from '@/libs/core/crud/store-accessors';
import {CrudGetter} from '@/libs/core/crud/crud-getter';
import {CrudEntity} from '@/libs/core/crud/crud-service';
import {CrudAction} from '@/libs/core/crud/crud-action';
import {StoreName} from '@/libs/core/store/store-name';

export function createStoreSyncPlugin(): Plugin<any> {
    const getStore = (storeName: StoreName) => ({
        dispatch: createStoreDispatcher(storeName),
        getter: createStoreGetter(storeName)
    });

    const onEvent = (subject: Subject<ObjectChangeEvent>, handler: (event: ObjectChangeEvent) => void) => subject.subscribe({
        next: handler,
        complete: () => undefined,
        error: (err: any) => console.error('Store sync failed', err)
    });

    return () => {
        onEvent(RealtimeClient.created, event => {
            const store = getStore(event.objectType);

            const relations = event.relations || {'': null};
            Object.keys(relations).forEach(relationKey => {
                const data: CrudEntity[] = store.getter(CrudGetter.Data, relations[relationKey]);
                if (data !== undefined) {
                    store.dispatch(CrudAction.GetAll, {
                        key: relations[relationKey], query: 'same', extra: {
                            ignoreKeySuffix: true,
                            command: event.command
                        }
                    })
                }
            });
        });

        onEvent(RealtimeClient.updated, event => {
            getStore(event.objectType).dispatch(CrudAction.PartialUpdate, {
                id: event.objectId,
                key: event.objectId,
                diff: event.diff,
                extra: {
                    local: true,
                    ignoreKeySuffix: true,
                    command: event.command
                }
            })
        });

        onEvent(RealtimeClient.deleted, event => {
            const store = getStore(event.objectType);

            const relations = event.relations || {'': null};
            Object.keys(relations).forEach(relationKey => {
                const data: CrudEntity[] = store.getter(CrudGetter.Data, relations[relationKey]);
                const detail: CrudEntity | null = store.getter(CrudGetter.Detail, relations[relationKey]);

                if (data?.find(item => item.id === event.objectId) || detail) {
                    store.dispatch(CrudAction.Delete, {
                        id: event.objectId,
                        key: relations[relationKey],
                        extra: {
                            ignoreKeySuffix: true,
                            command: event.command
                        }
                    })
                }
            });
        });
    };
}
